module.exports = __webpack_public_path__ + "img/boundary-show-hover.bd4a7f31.svg";